export var ColumnType;
(function (ColumnType) {
    ColumnType["BOOLEAN"] = "BOOLEAN";
    ColumnType["DATE"] = "DATE";
    ColumnType["DATETIME"] = "DATETIME";
    ColumnType["INTEGER"] = "INTEGER";
    ColumnType["FLOAT"] = "FLOAT";
    ColumnType["STRING"] = "STRING";
})(ColumnType || (ColumnType = {}));
export class DataColumn {
    constructor(name, type) {
        this._name = name;
        this._type = type;
    }
    get name() {
        return this._name;
    }
    get type() {
        return this._type;
    }
}
